<template>
<div ref="monitoringToolbar">
  <div>
    <span class="topology-icon-group">
      <w-map-show-filter class="mr-r13"></w-map-show-filter>
      <span class="linked-icons mr-r15">
        <w-map-button type="button" icon="btn-minimap" :toggle="true" tooltip="미니맵" @onClick="onMinimapBtnClick" :disabled="!currentMapId"></w-map-button>
        <w-map-button type="button" icon="btn-screenshot" tooltip="화면캡처" @onClick="onDownloadBtnClick" :disabled="!currentMapId"></w-map-button>
      </span>
      <span class="linked-icons mr-r15" v-if="isAutomap">
        <w-map-button type="button" icon="btn-layout-radial" tooltip="방사형 레이아웃" @onClick="onLayoutBtnClick(MapConst.LAYOUT_TYPE.RADIAL)" :disabled="!currentMapId"></w-map-button>
        <w-map-button type="button" icon="btn-layout-circle" tooltip="원형 레이아웃" @onClick="onLayoutBtnClick(MapConst.LAYOUT_TYPE.CIRCLE)" :disabled="!currentMapId"></w-map-button>
        <!-- <w-map-button type="button" icon="btn-layout-tree" tooltip="트리형 레이아웃" @onClick="onLayoutBtnClick(MapConst.LAYOUT_TYPE.TREE)" :disabled="!currentMapId"></w-map-button> -->
        <!-- <w-map-button type="button" icon="btn-layout-tree" tooltip="계층형 레이아웃" @onClick="onLayoutBtnClick(MapConst.LAYOUT_TYPE.HIERARCHIC)" :disabled="!currentMapId"></w-map-button> -->
        <w-map-button type="button" icon="btn-layout-custom" tooltip="수동 레이아웃" @onClick="onLayoutBtnClick(MapConst.LAYOUT_TYPE.CUSTOM)" :disabled="!currentMapId" v-if="isCustomChanged"></w-map-button>
      </span>
      <span class="linked-icons mr-r15">
        <w-map-button type="button" icon="btn-auto" tooltip="화면에 맞춰 표시" @onClick="onZoomFitBtnClick" :disabled="!currentMapId"></w-map-button>
        <w-map-button type="button" icon="btn-fit" tooltip="원래 크기로 표시" @onClick="onZoomResetBtnClick" :disabled="!currentMapId"></w-map-button>
        <w-map-button type="button" icon="btn-full" tooltip="전체화면" @onClick="onFullscreenBtnClick" :disabled="!currentMapId"></w-map-button>
      </span>
    </span>
    <el-button size="small" type="solid" @click="onEditBtnClick" :disabled="!currentMapId || isFullScreen" v-if="isSettingAuth">맵 편집</el-button>
  </div>
</div>
</template>

<script>
/* eslint-disable no-bitwise, no-void, max-len */
import vmodal from 'vue-js-modal';
import { remove, isNil } from 'lodash';

import AppAPI from '@/api/common/app';
import MapAPI from '@/api/topologymap/common';

import MapConst from '@/constants/topologymap';

import Toolbar from '@/mixins/topologymap/toolbar';

import { applicationLauncher } from '@/utils/applauncher';
import { isEmpty } from '@/utils/basic';
import { routePathByObjId } from '@/utils/router';
import { menuDefine } from '@/constants/menu';
import { performanceNodeTabs } from '@/constants/performance';

import WMapButton from '@/views/topologymap/components/MapButton';
import WEventListWindow from '@/views/topologymap/components/monitoring/EventListWindow';
import WMinimapWindow from '@/views/topologymap/components/monitoring/MinimapWindow';
import WObjectSearchWindow from '@/views/topologymap/components/monitoring/ObjectSearchWindow';
import WObjectElementWindow from '@/views/topologymap/components/edit/ObjectElementWindow';
import { Q, MapInfo, MapPopup } from '@/views/topologymap/js/maps';
import { makeTooltip } from '@/views/topologymap/js/tooltip';
import WDeviceInfoPopup from '@/views/topologymap/components/popup/DeviceInfoPopup';
import WVmDetailInfoWindow from '@/views/topologymap/components/monitoring/VmDetailInfoWindow';
import WMapShowFilter from '@/views/topologymap/components/monitoring/MapShowFilter';

export default {
  name: 'WTopologymapMonitoring',
  components: {
    WEventListWindow,
    WMinimapWindow,
    WObjectSearchWindow,
    WObjectElementWindow,
    WMapButton,
    WDeviceInfoPopup,
    WVmDetailInfoWindow,
    WMapShowFilter,
  },
  mixins: [Toolbar],
  data() {
    return {
      MapConst,
      searchBtnFlag: false,
      minimapBtnFlag: false,
    };
  },
  computed: {
  },
  created() {
  },
  mounted() {
    MapInfo.getInstance(this).setToolbar(MapConst.VIEW_MODE.MONITORING, this);
  },
  methods: {
    /**
     * 맵 모음 버튼 클릭
     * @author KangBonghun(toto1323)
     * @param  {[type]} btn [description]
     * @return {[type]}     [description]
     */
    onMapListBtnClick() {
    },
    /**
     * 관리대상 검색 버튼 클릭
     * @author KangBonghun(toto1323)
     * @param  {[type]} btn [description]
     * @return {[type]}     [description]
     */
    onSearchBtnClick(btn) {
      this.toggleWindowButton(WObjectSearchWindow, btn);
    },
    /**
     * 미니맵 버튼 클릭
     * @author KangBonghun(toto1323)
     * @param  {[type]} btn [description]
     * @return {[type]}     [description]
     */
    onMinimapBtnClick(btn) {
      this.toggleWindowButton(WMinimapWindow, btn);
    },
    /**
     * 슬라이드쇼 버튼 클릭
     * @author KangBonghun(toto1323)
     * @return {[type]} [description]
     */
    onSlideshowBtnClick() {
      // TODO : 슬라이드쇼 팝업창 띄우기
    },
    /**
     * 맵 다운로드 버튼 클릭
     * @author KangBonghun(toto1323)
     * @return {[type]} [description]
     */
    onDownloadBtnClick() {
      this.$mapEventBus.$emit(MapConst.MAP_EVENTBUS.MAP_DOWNLOAD, {
        model: MapInfo.getInstance(this).getGraph().topologymapModel,
      });
    },
    /**
     * 자동 확대/축소 버튼 클릭
     * @author KangBonghun(toto1323)
     * @return {[type]} [description]
     */
    onZoomFitBtnClick() {
      MapInfo.getInstance(this).getCanvas().zoomFit();
    },
    /**
     * 기본 확대/축소 버튼 클릭
     * @author KangBonghun(toto1323)
     */
    onZoomResetBtnClick() {
      MapInfo.getInstance(this).getCanvas().zoomReset();
    },
    /**
     * 전체화면 버튼 클릭
     * @author KangBonghun(toto1323)
     * @return {[type]} [description]
     */
    onFullscreenBtnClick() {
      MapInfo.getInstance(this).getCanvas().fullScreen();
    },
    onLayoutBtnClick(type) {
      MapInfo.getInstance(this).getCanvas().doAutoLayout(type, true);
    },
    /**
     * 편집 버튼 클릭
     * @author KangBonghun(toto1323)
     * @return {[type]} [description]
     */
    onEditBtnClick() {
      this.$store.commit('setTopologymapViewMode', MapConst.VIEW_MODE.EDIT);
    },
    /**
     * 툴바가 활성화되면 호출된다. (모니터링 모드로 전환된 경우)
     * @author KangBonghun(toto1323)
     * @return {[type]} [description]
     */
    onActivateToolbar() {
      const graph = MapInfo.getInstance(this).getGraph();
      if (graph) {
        const topologymapModel = graph.topologymapModel;
        const canvas = MapInfo.getInstance(this).getCanvas();

        graph.interactionMode = MapConst.INTERACTION.MONITORING;
        graph.editable = false;

        canvas.refreshMap(topologymapModel && topologymapModel.mapId, true);
      }
      window.ipaddressToConnectInfo = {};
      // 맵 트리 표현 여부를 로컬 스토리지에 저장 된 상태로 원복
      this.$store.commit('setMapTreeCollapse', localStorage.getItem('mapTreeCollapse') === 'true');
    },
    /**
     * 우클릭 했을 때 호출되며 컨텍스트 메뉴를 업데이트한다.
     * @author KangBonghun(toto1323)
     * @param  {[type]} evt [description]
     * @return {[type]}     [description]
     */
    oncontextmenu(evt) {
      // 컨텍스트 메뉴는 ADMIN, 관리자에게만 제공한다.
      if (this.getUserInfo.managerType !== 'ADMIN' && this.getUserInfo.managerType !== 'MANAGER') {
        return;
      }

      const target = evt.getData();

      if (target instanceof Q.ManagedObjectModel) {
        const model = target.get('model');
        const items = [{
          label: 'VM상세정보',
          execute: 'VM_INFO',
        }, {
          label: '연결장비 정보',
          execute: 'CONNECT_DEVICE_INFO',
        }, {
          label: '장비 표현 정보',
          execute: 'DEVICE_INFO',
        }, {
        //   label: '장비제어',
        //   execute: 'DEVICE_CONTROL',
        // }, {
        //   label: '관리자 접근 정보',
        //   execute: 'ADMINACCESSINFO',
        // }, {
          label: 'Ping',
          execute: 'PING',
        }, {
          label: '터미널',
          execute: 'TERMINAL',
        }, {
          label: 'Trace Route',
          execute: 'TRACE_ROUTE',
        }, {
          label: 'IP Scan',
          execute: 'IP_SCAN',
        }, {
          label: 'MIB Browser',
          execute: 'MIB_BROWSER',
        }, {
          label: 'Web Link',
          execute: 'LINK_WWW',
        }];

        if (model.objtypeId !== 'VVM') {
          remove(items, (item) => item.execute === 'VM_INFO');
        }
        if (model.objtypeId !== 'NETDEVICE') {
          remove(items, (item) => item.execute === 'CONNECT_DEVICE_INFO');
        }
        if (model.objtypeId === 'WIRELESSAP' && !isNil(model.parentObjId)) {
          remove(items, (item) => item.execute === 'PING');
          remove(items, (item) => item.execute === 'TERMINAL');
          remove(items, (item) => item.execute === 'TRACE_ROUTE');
          remove(items, (item) => item.execute === 'IP_SCAN');
          remove(items, (item) => item.execute === 'MIB_BROWSER');
        }
        if (!model.objId) {
          remove(items, (item) => item.execute === 'DEVICE_INFO');
          remove(items, (item) => item.execute === 'IP_SCAN');
        }
        if (model.objDefineId === 'SERVICE') {
          remove(items, (item) => item.execute !== 'DEVICE_INFO');
        }
        if (model.objManagetypeId !== 'NMS') {
          remove(items, (item) => item.execute === 'MIB_BROWSER');
        }

        this.$store.dispatch('showContextmenu', {
          items: items.map((item) => { item.type = MapConst.CONTEXT_MONITORING.APP; return item; }),
          evt,
          target: this,
          graph: MapInfo.getInstance(this).getGraph(),
        });
      }
    },
    /**
     * 컨텍스트 메뉴 아이템을 선택하면 호출된다.
     * @author KangBonghun(toto1323)
     * @param  {[type]} item 선택한 메뉴
     * @param  {[type]} evt  [description]
     * @return {[type]}      [description]
     */
    onContextMenuItemSelect(item, evt) {
      if (item.type === MapConst.CONTEXT_MONITORING.APP) { // 관리도구 일 경우
        switch (item.execute) {
          // 장비 표현 정보
          case 'DEVICE_INFO': {
            const graph = MapInfo.getInstance(this).getGraph();
            const selectedObject = graph.selectionModel.toDatas();
            if (selectedObject.length !== 1) {
              return;
            }
            const selectedObjectModel = selectedObject[0];
            MapInfo.getInstance(this).getPanel().$refs.deviceInfoPopup.open({ selectedObjectModel });
            break;
          }
          // 장비 제어
          case 'DEVICE_CONTROL': {
            const graph = MapInfo.getInstance(this).getGraph();
            const selectedObject = graph.selectionModel.toDatas();
            if (selectedObject.length !== 1) {
              return;
            }
            const selectedObjectModel = selectedObject[0];

            MapAPI.getObjInfoForControl(selectedObjectModel.get('objId')).then((response) => {
              const result = response.data;
              if (result.success) {
                this.$mapEventBus.$emit(MapConst.MAP_EVENTBUS.DEVICE_CONTROL, result.data);
              }
            });
            break;
          }
          // 관리자 접근 정보
          case 'ADMINACCESSINFO': {
            const target = MapInfo.getInstance(this).getGraph().selectionModel.toDatas()[0];
            const objId = target.get('model').objId;

            AppAPI.getAppExecuteInfo(objId).then((response) => {
              if (response.data.success && !isEmpty(response.data.data)) {
                const telnetInfoInObj = response.data.data;
                MapInfo.getInstance(this).getPanel().$refs.adminAccessInfoPopup.open(telnetInfoInObj);
              }
            });
            break;
          }
          // VM 상세 정보
          case 'VM_INFO': {
            const target = MapInfo.getInstance(this).getGraph().selectionModel.toDatas()[0];
            MapPopup.showPopup(WVmDetailInfoWindow, {
              config: {
                // x: evt.x,
                // y: evt.y,
              },
              data: {
                target,
              },
              events: {
                shown: function shown() {
                  const existedPopup = MapPopup.getPopup(WVmDetailInfoWindow.name).wrapper;
                  if (existedPopup) {
                    const existedPopupData = vmodal.dynamicContainer.modals.find((winItem) => winItem.config.name === WVmDetailInfoWindow.name);
                    const xy = MapPopup.getPivotXY(existedPopup.width, existedPopup.height, this.x || existedPopupData.config.x, this.y || existedPopupData.config.y);
                    existedPopupData.config.pivotX = xy.pivotX;
                    existedPopupData.config.pivotY = xy.pivotY;
                    existedPopup.shift = { left: 0, top: 0 };
                  }
                }.apply(evt),
              },
            });
            break;
          }
          // 연결장비 정보
          case 'CONNECT_DEVICE_INFO': {
            const graph = MapInfo.getInstance(this).getGraph();
            const selectedObject = graph.selectionModel.toDatas();
            if (selectedObject.length !== 1) {
              return;
            }
            const selectedObjectModel = selectedObject[0];
            this.$mapEventBus.$emit(MapConst.MAP_EVENTBUS.CONNECT_DEVICE_INFO, {
              objId: selectedObjectModel.get('objId'),
            });
            break;
          }
          // 관리도구
          default: {
            const target = MapInfo.getInstance(this).getGraph().selectionModel.toDatas()[0];
            const model = target.get('model');
            const objId = model.objId;

            if (model.isObj) { // 관리대상일 경우
              AppAPI.getAppExecuteInfo(objId).then((response) => {
                if (response.data.success && !isEmpty(response.data.data)) {
                  const obj = response.data.data;
                  if (item.execute === 'TERMINAL') {
                    item.execute = obj.useSSH ? 'SSH' : 'TELNET';
                  }
                  if (item.execute === 'IP_SCAN') {
                    applicationLauncher().openIpScanPopup(objId);
                  } else if (item.execute === 'MIB_BROWSER') {
                    applicationLauncher().openMibBrowserPopup(objId);
                  } else {
                    applicationLauncher().directExecute(item.execute, obj, this);
                  }
                }
              });
            } else if (model.isAutomapDevice) { // 연결장비 일 경우
              if (item.execute === 'TERMINAL') {
                item.execute = 'TELNET';
              }
              const obj = {
                ipaddressApplytype: 'IPv4',
                ipaddressIpv4: model.ipaddress,
                objtypeId: model.objtypeId,
              };
              applicationLauncher().directExecute(item.execute, obj, this);
            }
          }
        }
      } else if (item.type === MapConst.CONTEXT_MONITORING.MAP) { // 맵 이동일 경우
        if (this.currentMapId === item.mapId) {
          MapInfo.getInstance(this).getCanvas(MapConst.VIEW_MODE.MONITORING).initSelect(MapInfo.getInstance(this).getGraph(), {
            objId: item.objId,
            connectInfoParam: item.connectInfoParam,
          });
        } else {
          this.routeMap(item.mapId, {
            redirect: false,
            objId: item.objId,
            connectInfoParam: item.connectInfoParam,
          });
        }
      }
    },
    /**
     * 오브젝트를 클릭하면 호출된다.
     * @author KangBonghun(toto1323)
     * @param  {[type]} evt    [description]
     * @param  {[type]} target [description]
     * @return {[type]}        [description]
     */
    onClickTarget(evt, target) {
      if (target instanceof Q.ManagedObjectModel || target instanceof Q.LanModel || target instanceof Q.SubTopologymapModel || target instanceof Q.Custom1Model) {
        const model = target.get('model');
        const isLan = target instanceof Q.LanModel;
        if (isLan) {
          // 인터페이스가 하나도 맵핑되어있지 않으면 장비주요정보 팝업창을 띄우지 않는다.
          if ((model.srcObjId === -1 && model.dstObjId === -1) && (model.dstIfIndex === -1 && model.srcIfIndex === -1)) {
            return;
          }
        }

        if (this.isAutomap) { // 자동맵일 때 (노드, 회선)
          this.$mapEventBus.$emit(MapConst.MAP_EVENTBUS.AUTOMAP_MAJOR_INFO, target);
        } else if (!this.isAutomap && model.isAutomapDevice) { // 자동맵 아니고, 연결장비 일 때
          this.$mapEventBus.$emit(MapConst.MAP_EVENTBUS.AUTOMAP_MAJOR_INFO, target);
        } else if (!this.isAutomap && isLan) { // 자동맵이 아니고 회선일때
          // TODO:  회선에 대해 연결되어있는 node가 연결장비여부를 알 수 있는 flag값이 추가 된 후 from, to가 아닌 그 flag로 확인하도록 수정 필요
          const from = target.from.get('model');
          const to = target.to.get('model');
          if (from.isAutomapDevice || to.isAutomapDevice) {
            this.$mapEventBus.$emit(MapConst.MAP_EVENTBUS.AUTOMAP_MAJOR_INFO, target);
          } else {
            this.$mapEventBus.$emit(MapConst.MAP_EVENTBUS.MAJOR_INFO, target);
          }
        } else {
          this.$mapEventBus.$emit(MapConst.MAP_EVENTBUS.MAJOR_INFO, target);
        }
      }

      // if (target instanceof Q.ManagedObjectModel || (target instanceof Q.LanModel && target.from instanceof Q.ManagedObjectModel) || (target instanceof Q.LanModel && target.to instanceof Q.ManagedObjectModel) || target instanceof Q.SubTopologymapModel || target instanceof Q.Custom1Model) {
      //   const model = target.get('model');
      //   if (target instanceof Q.LanModel) {
      //     if (model.srcObjId === -1 && model.dstObjId === -1) {
      //       // 인터페이스가 하나도 맵핑되어있지 않으면 이벤트 리스트 팝업창을 띄우지 않는다.
      //       return;
      //     }
      //   }
      //
      //   // 장비주요정보 팝업창 open
      //   this.$mapEventBus.$emit(MapConst.MAP_EVENTBUS.MAJOR_INFO, target);
      //   //
      //   // // const l = MapInfo.getGraph().globalToLocal(evt);
      //   // MapPopup.showPopup(WEventListWindow, {
      //   //   config: {
      //   //     // x: evt.x,
      //   //     // y: evt.y,
      //   //   },
      //   //   data: {
      //   //     target,
      //   //   },
      //   //   events: {
      //   //     shown: function shown() {
      //   //       const existedPopup = MapPopup.getPopup(WEventListWindow.name).wrapper;
      //   //       if (existedPopup) {
      //   //         const existedPopupData = vmodal.dynamicContainer.modals.find((item) => item.config.name === WEventListWindow.name);
      //   //         const xy = MapPopup.getPivotXY(existedPopup.width, existedPopup.height, this.x || existedPopupData.config.x, this.y || existedPopupData.config.y);
      //   //         existedPopupData.config.pivotX = xy.pivotX;
      //   //         existedPopupData.config.pivotY = xy.pivotY;
      //   //         existedPopup.shift = { left: 0, top: 0 };
      //   //       }
      //   //     }.apply(evt),
      //   //   },
      //   // });
      // }
    },
    /**
     * 오브젝트를 더블클릭하면 호출된다.
     * @author KangBonghun(toto1323)
     * @param  {[type]} evt    [description]
     * @param  {[type]} target [description]
     * @return {[type]}        [description]
     */
    ondblClickTarget(evt, target) {
      // 하위상황판 이동
      if (target instanceof Q.SubTopologymapModel) {
        // 권한체크
        if (target.get('model').auth) {
          const mapId = target.get('model').mapId;

          this.routeMap(mapId);
        } else {
          this.$message.info('접근 권한이 없습니다.');
        }
      } else if (target instanceof Q.ManagedObjectModel || target instanceof Q.LanModel) {
        let objId;
        if (target instanceof Q.ManagedObjectModel) {
          objId = target.get('objId');
        } else if (target instanceof Q.LanModel) {
          const srcObjId = target.get('srcObjId');
          const dstObjId = target.get('dstObjId');
          if (srcObjId && dstObjId) {
            if (srcObjId !== -1 && dstObjId !== -1) objId = srcObjId;
            else if (srcObjId !== -1) objId = srcObjId;
            else if (dstObjId !== -1) objId = dstObjId;
            else return;
          }
        }

        if (objId) {
          this.showDetailPopup(objId);
        }
      }
    },
    /**
     * 관련 메뉴 이동
     * @author KangBonghun(toto1323)
     * @param  {[type]} objId [description]
     * @return {[type]}        [description]
     */
    showDetailPopup(objId) {
      routePathByObjId(this, objId, menuDefine.PERF_OPER, performanceNodeTabs.summary.name);
    },
    /**
     * 맵 리스트 메뉴를 보여준다.
     * @author KangBonghun(toto1323)
     * @param  {[type]}   evt      [description]
     * @param  {[type]}   obj    [description]
     * @param  {Function} callback [description]
     * @return {[type]}            [description]
     */
    showMapListMenu(evt, obj, callback) {
      const { objId, connectInfoParam } = obj;
      MapAPI.getMaplistByObjId(objId).then((response) => {
        const contextMenus = response.data.data.map((value) => ({
          label: value.label,
          mapId: value.mapId,
          objId: value.objId,
          connectInfoParam,
          type: MapConst.CONTEXT_MONITORING.MAP,
        }));
        this.$store.dispatch('showContextmenu', {
          items: contextMenus,
          evt,
          target: this,
          graph: MapInfo.getInstance(this).getGraph(),
        });

        if (callback) {
          callback.call();
        }
      });
    },
    /**
     * 오브젝트의 툴팁을 세팅한다.
     * @author KangBonghun(toto1323)
     * @param  {[type]} target [description]
     */
    setModelToolTip(target) {
      if (!target.tooltip || target.tooltip === '') {
        target.tooltip = ' ';

        const elementId = target.get('elementId');
        const objManagetypeId = target.get('objManagetypeId');
        let objDefineId = target.get('objDefineId');
        const objtypeId = target.get('objtypeId');

        // APM, BMS, E2E 는 툴팁을 표현하지 않는다.
        if (['APM', 'BMS', 'E2E'].some((item) => item === objManagetypeId)) {
          return;
        }

        // VMS 는 objDefineId로 구분 할 수 없으므로 objtypeId로 변경한다.
        if (objManagetypeId === 'VMS') {
          objDefineId = target.get('objtypeId');
        }

        MapAPI.getTooltipInfo(elementId, objManagetypeId, objDefineId, objtypeId, target instanceof Q.LanModel).then((response) => {
          let tooltip = '';
          const result = response.data;
          if (result.success) {
            const tipData = result.data;
            if (!isEmpty(tipData)) {
              tooltip = makeTooltip(tipData, target, objManagetypeId, objDefineId);
            }
          } else {
            tooltip = '';
          }

          target.tooltip = tooltip;

          // 툴팁 DOM은 기본적으로 body 영역에 생성된다.  전체화면시 여러가지 문제점이 있으므로 토폴로지맵 패널 DOM 하위로 위치를 변경한다.
          try {
            // MapInfo.getInstance(this).getPanel().$el.appendChild(document.querySelector('.Q-Tooltip'));
          } catch (e) {
            // ignore
          }
        });
      }
    },
  },
};
/* eslint-enable no-bitwise, no-void, max-len */
</script>



// WEBPACK FOOTER //
// src/views/topologymap/layout/TopologymapMonitoring.vue